var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZklinkNova(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5901_1438)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0018 0L18.2161 3.59745V10.0101L23.7453 13.2109V20.4026L17.531 24.0001L12.0046 20.8009L12.0018 20.8025L11.9949 20.7985L6.4643 24.0001L0.25 20.4026V13.2109L5.78751 10.0053V3.59745L12.0018 0ZM17.531 22.4273L13.363 20.0145L18.2161 17.205V11.5828L22.3842 13.9957V19.6178L17.531 22.4273ZM16.855 4.38225V9.22534L12.0018 6.41586L7.14866 9.22534V4.38225L12.0018 1.57277L16.855 4.38225ZM12.0018 7.98862L7.83421 10.4012L10.9407 12.1996C11.2237 11.9413 11.6002 11.7838 12.0134 11.7838C12.4223 11.7838 12.7952 11.938 13.0771 12.1914L16.1694 10.4012L12.0018 7.98862ZM13.6029 13.4635L16.855 11.5808V16.4202L12.6786 18.8379V14.8223C13.2005 14.582 13.5701 14.0675 13.6029 13.4635ZM10.4249 13.479C10.4624 14.0639 10.8157 14.5628 11.3161 14.8071V18.8328L7.14866 16.4202V11.5824L10.4249 13.479ZM1.61114 13.9957L5.78751 11.578V17.205L10.6364 20.0121L6.4643 22.4273L1.61114 19.6178V13.9957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5901_1438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZklinkNova);
export default __webpack_public_path__ + "static/media/zklink-nova.21ac91ee1419642dd621ad138f1c872f.svg";
export { ForwardRef as ReactComponent };